export const USER_GROUP = {
  IT: "IT",
};

export interface MenuPermission {
  menuCode: string;
  menuName: string;
  path: string;
  actions: string[];
  groupIds?: string[];
}

export interface Permission {
  appCode: string;
  appName: string;
  appDesc?: string;
  appImg?: string;
  appPath?: string;
  externalLink?: string;
  menus?: MenuPermission[];
  groupIds?: string[];
}

export interface UserMetaData {
  firstName: string;
  lastName: string;
}

export interface Profile {
  username: string;
  name: string;
  email: string;
  first_name: string;
  last_name: string;
  user_metadata: UserMetaData;
  groups: string[];
  permissions?: Permission[];
  partner: string;
}

export interface PostPermissionsRequest {
  empty: true;
}

export interface PostPermissionResponse {
  permissions: Permission[];
}
